import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "filter-label" };
const _hoisted_2 = { class: "filter-value-container" };
const _hoisted_3 = {
    key: 0,
    class: "filter-button-value-suffix"
};
const _hoisted_4 = ["id"];
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "flex mt-5 mb-2 justify-end" };
const _hoisted_7 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnMenu"], {
        ref: "menuComponent",
        "close-on-content-click": false,
        class: "filter-menu p-0 z-2500 max-h-[calc(100vh-72px)] overflow-y-auto",
        "collision-padding": $setup.collisionPadding,
        sticky: "always",
        "prioritize-position": "",
        "should-keep-focus": "",
        persistent: "",
        "no-click-animation": "",
        "offset-y": "",
        "onUpdate:open": _cache[1] || (_cache[1] = (val) => $setup.modelValue = val),
        "onClick:outside": $setup.onClickOutside,
        onKeydown: [
            _cache[2] || (_cache[2] = _withKeys(($event) => ($setup.closeMenu()), ["enter"])),
            _cache[3] || (_cache[3] = _withKeys(($event) => ($setup.closeMenu()), ["esc"]))
        ]
    }, {
        trigger: _withCtx(() => [
            _createVNode($setup["EnButton"], {
                class: _normalizeClass(["filter-container-button justify-start", { 'hovered': $setup.modelValue }]),
                "static-id": $props.id,
                onClick: $setup.handleClick
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "label", {}, undefined, true)
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "prefix", {}, undefined, true),
                        _renderSlot(_ctx.$slots, "display-string", {}, () => [
                            _createElementVNode("div", {
                                class: _normalizeClass(["filter-button-value truncate max-w-[min(90vw,500px)]", { 'has-suffix': _ctx.$slots['display-string-suffix'] }])
                            }, [
                                _createElementVNode("b", null, _toDisplayString($props.displayString), 1 /* TEXT */)
                            ], 2 /* CLASS */)
                        ], true),
                        (_ctx.$slots['display-string-suffix'])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _renderSlot(_ctx.$slots, "display-string-suffix", {}, undefined, true)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("span", {
                        id: $setup.buildStaticId('en-base-action-button-reset', $props.id),
                        class: "remove-filter-icon",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => ($props.resetFilter?.($event)), ["stop"]))
                    }, [
                        _createVNode($setup["ChevronDown"], {
                            class: "context-menu-icon",
                            size: 19
                        }),
                        _createVNode($setup["X"], {
                            class: "close-icon-wrapper",
                            size: 19
                        })
                    ], 8 /* PROPS */, _hoisted_4)
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["class", "static-id"])
        ]),
        default: _withCtx(() => [
            ($props.isActionButtonsRendered)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["search-input", $props.searchInputClass])
                }, [
                    ($props.label)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($props.label), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" @slot The filter button's content. "),
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
                    _createElementVNode("div", _hoisted_6, [
                        ($props.resetButtonText)
                            ? (_openBlock(), _createBlock($setup["EnButton"], {
                                key: 0,
                                "static-id": "filter-reset-button",
                                class: "mr-2",
                                size: "xs",
                                onClick: $setup.emitOnResetButtonClicked
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($props.resetButtonText), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true),
                        (!$props.hideApplyButton && $props.applyButtonText)
                            ? (_openBlock(), _createBlock($setup["EnButton"], {
                                key: 1,
                                "static-id": "filter-apply-button",
                                variant: "default",
                                size: "xs",
                                onClick: $setup.emitApplyFilters
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($props.applyButtonText), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true)
                    ])
                ], 2 /* CLASS */))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createCommentVNode(" @slot The filter button's content. "),
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]))
        ]),
        _: 3 /* FORWARDED */
    }, 512 /* NEED_PATCH */));
}
